import * as React from 'react'
import { cn } from '../../lib/utils'

export interface PanelFiltersProps extends React.HTMLAttributes<HTMLDivElement> {
	/** Left-side slot — typically a list of <Select> filters */
	filters?: React.ReactNode
	/** Right-side slot — typically a search input + primary action */
	actions?: React.ReactNode
}

/**
 * Horizontal filter bar for list panels.
 * Maps to Figma "Panel Filters" — filters on the left, search + CTA on the right.
 */
const PanelFilters = React.forwardRef<HTMLDivElement, PanelFiltersProps>(
	({ className, filters, actions, children, ...props }, ref) => (
		<div
			ref={ref}
			className={cn(
				'flex items-center justify-between gap-4 p-4 bg-(--color-background)',
				className
			)}
			{...props}
		>
			<div className="flex items-center gap-2 flex-wrap min-w-0">
				{filters ?? children}
			</div>
			{actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
		</div>
	)
)

PanelFilters.displayName = 'PanelFilters'
export { PanelFilters }
